import React from "react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Phone, Mail, MapPin, Globe, ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";
export default function TrustedPlumbingPartner() {
  return <section id="trustedplumbingpartner" className="w-full py-10 border-y border-border/10 bg-slate-50 text-left">
      <div className="container ml-0 mr-auto px-4 md:px-6">
        <div className="max-w-4xl ml-0 mr-auto">
          <div className="flex flex-col space-y-6">
            <div className="space-y-4">
              <div className="flex flex-wrap items-center gap-4">
                <h2 className="text-2xl font-extrabold tracking-tight text-blue-800/70 bg-white px-3 py-1.5 rounded-lg shadow-sm font-sans md:text-4xl">
                  Trusted Plumbing & Heating Partner
                </h2>
                <div className="flex items-center gap-3">
                  <Badge variant="outline" className="text-[10px] px-1.5 py-0 h-5 text-blue-800 bg-white border-blue-200">
                    COLLABORATION
                  </Badge>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1571404/img/wps_plumbing_logo.png" alt="WPS Logo" className="h-6 w-auto object-contain" />
                </div>
              </div>
              <p className="text-lg font-medium bg-white/90 p-4 rounded-lg leading-relaxed font-sans max-w-3xl border border-blue-100/50 text-slate-600">
                SimProTiling works in collaboration with <span className="font-bold text-blue-900">WPS – Waternight Plumbing Services</span>, a professional London plumbing and heating company specialising in boiler installations, central heating systems, underfloor heating and complete bathroom plumbing solutions.
              </p>
            </div>

            <div className="max-w-2xl border-t border-blue-200/40 pt-6">
              <div className="bg-white/40 backdrop-blur-md rounded-sm border border-blue-100 p-4 shadow-sm text-slate-700">
                <div className="text-[9px] font-bold text-blue-900/50 uppercase tracking-[0.2em] mb-3 flex items-center gap-3">
                  <span className="w-6 h-[1px] bg-accent"></span>
                  Partner Contact Details
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 text-xs">
                  <div className="space-y-2">
                    <div className="flex items-start gap-2.5 text-blue-900/80">
                      <MapPin className="w-3.5 h-3.5 mt-0.5 shrink-0 text-accent" />
                      <span className="leading-tight font-medium">Downhurst Avenue, Mill Hill, London NW7 3QA</span>
                    </div>
                    <div className="flex items-center gap-2.5 text-blue-900/80">
                      <Phone className="w-3.5 h-3.5 shrink-0 text-accent" />
                      <Link to="tel:02089599988" className="hover:text-accent transition-colors font-bold">020 8959 9988</Link>
                    </div>
                  </div>
                  <div className="space-y-2">
                    <div className="flex items-center gap-2.5 text-blue-900/80">
                      <Mail className="w-3.5 h-3.5 shrink-0 text-accent" />
                      <Link to="mailto:info@wpsuk.co.uk" className="hover:text-accent transition-colors font-bold">info@wpsuk.co.uk</Link>
                    </div>
                    <div className="flex items-center gap-2.5 text-blue-900/80">
                      <Globe className="w-3.5 h-3.5 shrink-0 text-accent" />
                      <Link to="https://wpsuk.co.uk/" newTab className="hover:text-accent transition-colors font-bold">wpsuk.co.uk</Link>
                    </div>
                    <div className="flex items-center gap-2 text-blue-800/50 text-[9px] font-bold pt-0.5">
                      <ShieldCheck className="w-3 h-3 shrink-0 text-accent" />
                      <span className="uppercase tracking-widest">Gas Safe Registered: 142716</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-3 pt-1">
              <Button asChild size="sm" className="h-8 text-xs rounded-sm bg-blue-600 hover:bg-blue-700 text-white shadow-sm transition-all hover:-translate-y-0.5 active:translate-y-0 border-none">
                <Link to="https://wpsuk.co.uk/" newTab>Visit WPS Website</Link>
              </Button>
              <Button asChild size="sm" className="h-8 text-xs rounded-sm bg-black hover:bg-slate-900 text-white shadow-sm transition-all hover:-translate-y-0.5 active:translate-y-0 border-none">
                <Link to="tel:02089599988">Call Plumbing Partner</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}